import { Box, Button, Flex, Text } from "@chakra-ui/react";
import { FC } from "react";

import { SectionCard } from "~/src/components/common/SectionCard";
import { chakraFactory } from "~/src/lib/chakra-ui";

import { type CompiledSnapshot, SnapshotHistory } from "./SnapshotHistory";

const StyledSectionCard = chakraFactory(SectionCard, {
  baseStyle: {
    maxWidth: "800px",
    margin: "24px auto 0 auto",
  },
});

type Props = {
  compiledSnapshots: CompiledSnapshot[];
  onActivateSnapshot: (snapshotId: string) => Promise<void>;
  onShowSnapshotDiff: (
    snapshotA: CompiledSnapshot,
    snapshotB: CompiledSnapshot
  ) => void;
  onOpenVersionCompare: () => void;
  isLoading?: boolean;
};

export const VersionHistoryTab: FC<Props> = ({
  compiledSnapshots,
  onActivateSnapshot,
  onShowSnapshotDiff,
  onOpenVersionCompare,
  isLoading,
}) => {
  return (
    <Box>
      <StyledSectionCard>
        <Flex align="center" justify="space-between" mb="24px">
          <Text fontWeight="500" fontSize="13px" color="#000000">
            バージョン履歴
          </Text>
          <Button size="sm" colorScheme="blue" onClick={onOpenVersionCompare}>
            バージョン比較
          </Button>
        </Flex>
        <SnapshotHistory
          snapshots={compiledSnapshots}
          onActivateSnapshot={onActivateSnapshot}
          onShowDiff={onShowSnapshotDiff}
          isLoading={isLoading}
        />
      </StyledSectionCard>
    </Box>
  );
};
